const version = "1.8.4";

export default version;
